import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { ChartTooltip } from "@/shared/ui/ChartTooltip";
import { useChartTheme } from "@/shared/hooks/useChartTheme";
import { useTranslation } from "@/shared/providers/LanguageProvider";

type BalanceChartProps = {
  data: BalanceDataPoint[];
  activeView: BalanceView;
};

export function BalanceChart({ data, activeView }: BalanceChartProps) {
  const { tick, expenses } = useChartTheme();
  const { t } = useTranslation();

  return (
    <div className="min-w-0 flex-1">
      <ResponsiveContainer width="100%" height={220}>
        <AreaChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="ordersGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#4680ff" stopOpacity={0.25} />
              <stop offset="100%" stopColor="#4680ff" stopOpacity={0.02} />
            </linearGradient>
            <linearGradient id="expensesGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={expenses} stopOpacity={0.3} />
              <stop offset="100%" stopColor={expenses} stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <XAxis
            dataKey="month"
            axisLine={false}
            tickLine={false}
            tick={{ fill: tick, fontSize: 12 }}
            dy={8}
            tickFormatter={(v) => t.common.months[v] ?? v}
          />
          <YAxis hide />
          <Tooltip content={<ChartTooltip />} />
          <Area
            type="monotone"
            dataKey="expenses"
            stroke={expenses}
            strokeWidth={activeView === "expenses" ? 2.5 : 2}
            fill="url(#expensesGradient)"
            opacity={activeView === "orders" ? 0.6 : 1}
          />
          <Area
            type="monotone"
            dataKey="orders"
            stroke="#4680ff"
            strokeWidth={activeView === "orders" ? 2.5 : 2}
            fill="url(#ordersGradient)"
            opacity={activeView === "expenses" ? 0.6 : 1}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
